import axiosClient from "api/apiClient";

export const APIGetSubjects = () => {
  return axiosClient.get("/subjects");
};
